import { render } from "./fitness.vue?vue&type=template&id=38f53368"
import script from "./fitness.vue?vue&type=script&lang=js"
export * from "./fitness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__